/** check if color is valid */
export const isValidColor = (str) => {
  const s = new Option().style
  s.color = str;
  return s.color !== ''
}

/** resolve color to conditional setting */
export const resolveColor = (setting, value) => {
  if (!setting && setting !== '') return null

  /** direct string color */
  if (typeof setting === 'string') {
    return isValidColor(setting) ? setting : null
  }

  /** object mapping { key: color, ... } */
  if (typeof setting === 'object') {
    const key = String(value)

    /** direct property match (handles numeric keys too) */
    if (Object.prototype.hasOwnProperty.call(setting, key) && isValidColor(setting[key])) {
      return setting[key]
    }

    /** case-insensitive match when value is a string */
    if (typeof value === 'string') {
      const lower = value.toLowerCase()
      for (const k in setting) {
        if (k.toLowerCase() === lower && isValidColor(setting[k])) {
          return setting[k]
        }
      }
    }

    /** fallback to else */
    if (Object.prototype.hasOwnProperty.call(setting, 'else') && isValidColor(setting['else'])) {
      return setting['else']
    }
  }

  return null;
}

/** get custom color style */
export const getCustomTextStyle = (textColor, bgColor, value) => {
   const style = {}

   const resolvedBg = resolveColor(bgColor, value)
   const resolvedText = resolveColor(textColor, value)

   if (resolvedBg) {
      style.padding = '0 10px'
      style.borderRadius = '4px'
      style.backgroundColor = resolvedBg
   }

   if (resolvedText) {
      style.color = resolvedText
   }

   return style
}

/** get whole style */
const getStyleProgressStatus = (status) => {
   if (status) {
      let progressBackgroundColor = 'grey'
      let progressTextColor = 'white'

      if (status.progress > 0 && status.progress <= 10) {
         // open
         progressBackgroundColor = '#dfe1e6'
         progressTextColor = '#42526e'
      } else if (status.progress >= 90 && status.progress <= 100) {
         // done
         progressBackgroundColor = '#e3fcef'
         progressTextColor = '#006644'
         // progressBackgroundColor = '#00875a'
         // progressTextColor = 'white'
      } else if (status.progress > 10 && status.progress < 90) {
         // in progress
         progressBackgroundColor = '#deebff'
         progressTextColor = '#0747a6'
         // progressBackgroundColor = '#0052cc'
         // progressTextColor = 'white'
      } else {
         progressBackgroundColor = '#e0e0e0'
         progressTextColor = 'black'
      }

      return {
         padding: '0 10px',
         fontWeight: '500',
         borderRadius: '4px',
         backgroundColor: progressBackgroundColor,
         color: progressTextColor
      }
   } else {
      return {}
   }
}

/** get partial style (color only) */
export const getStatusColor = (status) => {
   let progressBackgroundColor = 'grey'
   let progressTextColor = 'white'
   if (status) {
     if (status.progress > 0 && status.progress < 10) {
       /** open */
       progressBackgroundColor = '#dfe1e6'
       progressTextColor = '#42526e'
     } else if (status.progress >= 90 && status.progress <= 100) {
       /** done */
       progressBackgroundColor = '#00875a'
       progressTextColor = 'white'
     } else if (status.progress >= 10 && status.progress < 90) {
       /** in progress */
       progressBackgroundColor = '#0052cc'
       progressTextColor = 'white'
     } else {
       /** default */
       progressBackgroundColor = 'grey'
       progressTextColor = 'white'
     }
   }
 
   return { progressBackgroundColor, progressTextColor }
 }

export default getStyleProgressStatus